import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { admin as adminApi, setToken, getCampaignId } from '../api/client.js';
import { useAuth } from '../auth/AuthContext.jsx';

export default function ImpersonationBanner() {
  const { user, campaigns, loadUser } = useAuth();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const mandataire = useMemo(() => {
    const active = campaigns.find((c) => c.campaignId === getCampaignId()) || campaigns[0];
    return active?.mandataireCode || active?.role || '';
  }, [campaigns]);

  if (!user?.impersonatedBy) return null;

  const stop = async () => {
    setBusy(true);
    setError('');
    try {
      const out = await adminApi.stopImpersonation();
      setToken(out.token);
      await loadUser();
      navigate('/admin/users', { replace: true });
    } catch (err) {
      setError(err.message || 'Erreur stop impersonation');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="bg-amber-100 border-b border-amber-300 text-amber-950 px-4 py-2 text-sm flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
      <div>
        <strong>Connecte en tant que {user.name}</strong>
        {mandataire ? <span> / {mandataire}</span> : null}
        {error ? <span className="ml-2 text-red-700">{error}</span> : null}
      </div>
      <button
        type="button"
        onClick={stop}
        disabled={busy}
        className="self-start md:self-auto px-3 py-1 text-xs font-medium rounded-md bg-amber-900 text-white hover:bg-amber-800 disabled:opacity-50"
      >
        {busy ? 'Stop...' : 'Stop'}
      </button>
    </div>
  );
}
